
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"currentColor","stroke":"currentColor","stroke-width":".5","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M15.33 14.219a.225.225 0 00.225-.225V6.348a.225.225 0 00-.225-.224H8.808a.4.4 0 01-.222-.091L8 5.447a.836.836 0 00-.539-.223H4.986a.225.225 0 00-.225.225v8.545a.225.225 0 00.225.225zm-.225-6.746H5.211V5.674h2.25a.4.4 0 01.218.091l.586.586a.84.84 0 00.54.223h6.3zm0 .45v5.846H5.211V7.924z"}}),_c('path',{attrs:{"d":"M10.78 10.106a.225.225 0 11.318-.318l.9.9a.225.225 0 010 .318l-.9.9a.225.225 0 01-.318-.318l.516-.52H8.474a.225.225 0 110-.45h2.821z"}})])])
          )
        }
      }
    